export default {
  ACCOUNTS: '/agent/accounts',
  ACCOUNTS_BY_ACCOUNT_NUMBER: (accountNumber?: string) => `/agent/accounts?accountNumber=${accountNumber}`,
  ACCOUNTS_BY_NAME: (accountName: string) => `/agent/accounts?accountName=${accountName}`,
  ACCOUNTS_BY_NUMBER: (accountNumber: string) => `/agent/accounts?accountNumber=${accountNumber}`,
  ACCOUNT_DETAILS: (accountId: string, accountNumber: string) =>
    `/agent/accounts/${accountId}/accountNumber/${accountNumber}`,
  ACCOUNT_DISCREPANCIES: (accountNumber: string, accountId: string) =>
    `/agent/accounts/${accountNumber}/discrepancies/${accountId}`,
  ACCOUNT_DISCREPANCY_SUMMARIES: (accountId: string, accountNumber: string, sourceId: string, paymentDate: string) =>
    `/agent/accounts/${accountId}/discrepancySummaries?accountNumber=${accountNumber}&sourceId=${sourceId}&paymentDate=${paymentDate}`,
  POLICY_INFORMATION_REPORTS: '/agent/accounts/reports/policyInformationReport',
};
